
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 24.291v-.458c0-1.498.926-2.31 1.854-2.933.905-.61 1.813-1.406 1.813-2.873A3.666 3.666 0 0022 14.36a3.666 3.666 0 00-3.667 3.667","stroke":"#DD8500","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.998 29.333a.458.458 0 10.004.917.458.458 0 00-.004-.917","stroke":"#3084B9","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"22","cy":"22","r":"17","stroke":"#363636","stroke-width":"2"}})])
          )
        }
      }
    